import React, { useState, useEffect } from "react";

import {
  styleguideService,
  styleguidePropertyKeys,
} from "@Shared/Service/StyleguideService";

import { IconPicker as Picker } from "@caelor/ui";
import { MACRO_EDIT_EVENTS } from "@Shared/events/macro-edit-events";

import "emoji-mart/css/emoji-mart.css";
import "simplebar/dist/simplebar.min.css";

const IconPicker = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [appIcons, setAppIcons] = useState([]);

  useEffect(() => {
    styleguideService
      .getProperty(styleguidePropertyKeys.APP_ICONS)
      .then((response) => response && setAppIcons(response.data || []))
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    window.AP.events.on(MACRO_EDIT_EVENTS.OPEN_ICON_PICKER, () =>
      setIsOpen(true)
    );
  }, []);

  return (
    <Picker
      {...props}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      appIcons={appIcons}
      containerStyles={{ top: "75px" }}
    />
  );
};

export default IconPicker;
